function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import fly from './http';
import { UrlType, DefaultPayMerchantGetterVersion } from './constants';
function handleToken(urlType) {
  var _fly$config, _fly$config$extra;
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var accessToken = ((_fly$config = fly.config) === null || _fly$config === void 0 ? void 0 : (_fly$config$extra = _fly$config.extra) === null || _fly$config$extra === void 0 ? void 0 : _fly$config$extra.accessToken) || token;
  var opts = {
    headers: {
      urlType: urlType
    }
  };
  if (!!accessToken) {
    opts.headers['SUB-Access-Token'] = accessToken;
  }
  return opts;
}
/**
 * **接口** [获取商品详情↗](http://apidoc.inshopline.com/#/project/148/master/interface/86d4ff47e36076759a75721ad1e7e792)
 * @请求头 `POST /product/get`
 * @更新时间 `2022-02-17 17:24:15`
 */
export function postProductGet(data) {
  var opts = handleToken(UrlType.SUB);
  return fly.post("/product/get", data, opts);
}
export var EPromotionType;
(function (EPromotionType) {
  EPromotionType[EPromotionType["PROMOTION"] = 3] = "PROMOTION";
  EPromotionType[EPromotionType["PARTNER"] = 4] = "PARTNER";
  EPromotionType[EPromotionType["SHIP_PROMOTION_PACK"] = 5] = "SHIP_PROMOTION_PACK";
  EPromotionType[EPromotionType["SHIP_PROMOTION_PACK_SUB"] = 6] = "SHIP_PROMOTION_PACK_SUB";
})(EPromotionType || (EPromotionType = {}));
/**
 * **接口** [商品计价↗](http://apidoc.inshopline.com/#/project/148/master/interface/808555426b5502a4605f94d19519f343)
 * @请求头 `POST /sub/calculatePrice`
 * @参数 data 请求数据
 * @参数 token shophub会单独使用这个接口，所以开放这个接口让其自行传入token
 * @更新时间 `2022-02-22 10:01:33`
 */
export function calculatePriceByProduct(data, token) {
  var opts = handleToken(UrlType.SUB, token);
  return fly.post("/order/calculatePrice", data, opts);
}
/**
 * **接口** [获取账单详情↗](http://apidoc.inshopline.com/#/project/123/feature%2FDY-157-platform_bill/interface/9db1363ce7f4bc686049d4370faf964c)
 * @请求头 `GET /api/bill/platform/bill/getDetail`
 * @更新时间 `2022-02-22 11:28:15`
 */
export function getBillDetail(params) {
  var opts = handleToken(UrlType.BILL);
  return fly.get("/bill/getDetail", params, opts);
}
/**
 * **接口** [计算下一期套餐的开始结束时间---暂用于物流、广告的订阅使用↗](http://apidoc.inshopline.com/#/project/148/test/interface/e16899e7ed4efd757aec7b79fef07ed6)
 * @请求头 `POST /sub/calculateNextSubInfo`
 * @更新时间 `2022-07-07 16:55:29`
 */
export function postCalculateNextSubInfo(data) {
  var opts = handleToken(UrlType.SUB);
  return fly.post("/sub/calculateNextSubInfo", data, opts);
}
/**
 * **接口** [获取订单商品详情↗](http://apidoc.inshopline.com/#/project/148/master/interface/be6512aa01a2e90a10929f94348edf45)
 * @请求头 `POST /order/getByBillId`
 * @更新时间 `2022-02-22 15:38:18`
 */
export function getProductInfoByBillId(data) {
  var opts = handleToken(UrlType.SUB);
  return fly.post("/order/getByBillId", data, opts);
}
/**
 * **接口** [获取支付id初始化SDK↗](http://apidoc.inshopline.com/#/project/123/feature%2FDY-157-platform_bill/interface/e4fd87d6e217ca01fec9286aa5f5f2de)
 * @请求头 `GET /api/bill/platform/pay/getPayMerchantId`
 * @更新时间 `2022-02-22 16:36:10`
 */
export function getGetPayMerchantId(params) {
  var opts = handleToken(UrlType.BILL);
  return fly.get("/pay/getPayMerchantId", _objectSpread(_objectSpread({}, params), {}, {
    version: DefaultPayMerchantGetterVersion
  }), opts);
}
/**
 * **接口** [微信支付↗](http://apidoc.inshopline.com/#/project/123/feature%2Fsub_platform/interface/06c873fe13a83e389e46caa3add91cf2)
 * @请求头 `POST /api/bill/platform/pay/wechatPay`
 * @更新时间 `2022-02-22 16:36:10`
 */
export function postWechatPay(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/wechatPay", data, opts);
}
/**
 * **接口** [获取账单状态↗](http://apidoc.inshopline.com/#/project/123/feature%2Fsub_platform/interface/9081b5bbbd1959ea9625411988ab3565)
 * @请求头 `GET /api/bill/platform/bill/getStatus`
 * @更新时间 `2022-02-22 18:10:32`
 */
export function getBillStatus(params) {
  var opts = handleToken(UrlType.BILL);
  return fly.get("/bill/getStatus", params, opts);
}
/**
 * **接口** [基于账单计价↗](http://apidoc.inshopline.com/#/project/123/feature%2Fsub_platform/interface/d5fe7d3f7b6699a6d024d4566cefa5ee)
 * @请求头 `POST /api/bill/platform/pay/calculatePrice`
 * @更新时间 `2022-02-22 18:10:32`
 */
export function calcPriceByBillId(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/calculatePrice", data, opts);
}
/**
 * **接口** [创建付费套餐↗](http://apidoc.inshopline.com/#/project/148/master/interface/1370e476181e0715c0efb8cf70fa78c9)
 * @请求头 `POST /sub/create`
 * @更新时间 `2022-02-23 11:33:41`
 */
export function postSubCreate(data) {
  var opts = handleToken(UrlType.SUB);
  return fly.post("/sub/create", data, opts);
}
/**
 * **接口** [信用卡绑卡↗](http://apidoc.inshopline.com/#/project/123/feature%2Fsub_platform/interface/23437f47199a82a298ebf52bfa54c74b)
 * @请求头 `POST /api/bill/platform/pay/creditBind`
 * @更新时间 `2022-02-22 18:10:32`
 */
export function bindCreditCard(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/creditBind", data, opts);
}
/**
 * **接口** [信用卡支付(同时会自动完成绑卡动作)↗](http://apidoc.inshopline.com/#/project/123/feature%2Fsub_platform/interface/5f99aaaabd51770e05ec3dc6390d92b2)
 * @请求头 `POST /api/bill/platform/pay/creditPay`
 * @更新时间 `2022-02-22 18:10:32`
 */
export function bindCreditPay(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/creditPay", data, opts);
}
/**
 * **接口** [获取绑卡列表↗](http://apidoc.inshopline.com/#/project/123/feature%2Fsub_platform/interface/a2a86c58b6920a48c14bf1fd48a1e3d8)
 * @请求头 `GET /api/bill/platform/pay/listBindCard`
 * @更新时间 `2022-02-24 10:02:15`
 */
export function getListBindCard(params) {
  var opts = handleToken(UrlType.BILL);
  return fly.get("/pay/listBindCard", params, opts);
}
/**
 * **接口** [信用卡快捷支付↗](http://apidoc.inshopline.com/#/project/123/feature%2Fsub_platform/interface/2f1053fce63b333611625d38cefa72f3)
 * @请求头 `POST /api/bill/platform/pay/creditQuickPay`
 * @更新时间 `2022-02-24 10:02:15`
 */
export function postCreditQuickPay(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/creditQuickPay", data, opts);
}
/**
 * **接口** [获取可用的优惠信息↗](http://apidoc.inshopline.com/#/project/148/feature%2FDY-36_ship_promotion/interface/25a5a2f86141df0363425ba11d1cc816)
 * @请求头 `POST /promotion/getAvailablePromotions`
 * @更新时间 `2022-05-27 15:37:17`
 */
export function postGetAvailablePromotions(data) {
  var opts = handleToken(UrlType.SUB);
  return fly.post("/promotion/getAvailablePromotions", data, opts);
}
/**
 * **接口** [汇付支付↗](http://apidoc.inshopline.com/#/project/123/feature%2FDY-79_pay/interface/116055eb1fa8277323a8ad8b5d6d46d6)
 * @请求头 `POST /api/bill/platform/pay/huifuPay`
 * @更新时间 `2022-06-21 11:18:27`
 */
export function postHuifuPay(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/huifuPay", data, opts);
}
/**
 * **接口** [取消账单↗](http://apidoc.inshopline.com/#/project/123/feature%2FDY-38_appstore/interface/4abeda03c0b357e5eb2c86b441215a55)
 * @请求头 `GET /api/bill/platform/bill/cancel`
 * @更新时间 `2022-08-02 14:33:50`
 */
export function getBillCancel(params) {
  var opts = handleToken(UrlType.BILL);
  return fly.get("/bill/cancel", params, opts);
}
/**
 * **接口** [取消支付↗](http://apidoc.inshopline.com/#/project/259/develop/interface/518a1c955e9667f8b7035f0de0f7c279)
 * @请求头 `POST /api/bill/platform/pay/cancelPay`
 * @更新时间 `2023-04-27 19:45:30`
 */
export function postCancelPay(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.get("/bill/cancel", data, opts);
}
/**
 * **接口** [fpx支付↗](http://apidoc.inshopline.com/#/project/123/feature%2FDY-38_appstore/interface/e150e993edd1020cf49d7a440f307d3b)
 * @请求头 `POST /api/bill/platform/pay/fpxPay`
 * @更新时间 `2022-08-04 17:07:55`
 */
export function postPayFpxPay(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/fpxPay", data, opts);
}

/**
 * **接口** [xendit支付](http://apidoc.inshopline.com/#/project/123/dev/interface/674da5a43760bb6e9760f754dce736e1`
 * @更新时间 `2022-09-07 14:26:00`
 */
export function postPayXenditPay(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/xenditPay", data, opts);
}

/**
 * **接口** [paypal支付](http://apidoc.inshopline.com/#/project/123/dev/interface/674da5a43760bb6e9760f754dce736e1`
 * @更新时间 `2022-09-07 14:26:00`
 */
export function postPayPalPay(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/payPal", data, opts);
}
/**
 * **接口** [中台体系][获取待支付账单↗](http://apidoc.inshopline.com/#/project/148/master/interface/b7f21a42a40ab0489adae5229496baa5)
 * @请求头 `POST /bill/getPendingBill`
 * @更新时间 `2022-10-28 19:24:40`
 *
 * **接口** [主站体系][获取待支付账单↗](http://apidoc.inshopline.com/#/project/148/master/interface/f7a5249a97b3f6192d9a43185870b1b4)
 * @请求头 `POST /sl/bill/getPendingBill`
 * @更新时间 `2022-10-28 19:24:39`
 */
export function getGetPendingBill(data) {
  var opts = handleToken(UrlType.SUB);
  return fly.post("/bill/getPendingBill", data, opts);
}
/**
 * **接口** [查询应用优惠开关↗](http://apidoc.inshopline.com/#/project/148/dev/interface/c7984b5002500df185fdde321fc139c5)
 * @请求头 `POST /sl/promotion/getPromotionSwitch`
 * @更新时间 `2022-10-21 10:56:36`
 */
export function postGetPromotionSwitch(data) {
  var opts = handleToken(UrlType.SUB);
  return fly.post("/promotion/getPromotionSwitch", data, opts);
}
/**
 * **接口** [商家已绑定信用卡列表↗](http://apidoc.inshopline.com/#/project/123/dev/interface/9507e35cb2f8d065f9a1dbe52a1fc0b2)
 * @请求头 `GET /api/bill/platform/sl/pay/listMerchantBindCard`
 * @更新时间 `2022-11-14 10:38:40`
 */
export function getListMerchantBindCard() {
  var opts = handleToken(UrlType.BILL);
  return fly.get("/pay/listMerchantBindCard", {}, opts);
}
export var EPayChannel;
(function (EPayChannel) {
  EPayChannel["PENDING"] = "PENDING";
  EPayChannel["SUCCESS"] = "SUCCESS";
  EPayChannel["FAILED"] = "FAILED";
})(EPayChannel || (EPayChannel = {}));
/**
 * **接口** [获取支付状态↗](http://apidoc.inshopline.com/#/project/123/test/interface/b6085c288c3ff31dba4f3041ff8aa7ef)
 * @请求头 `POST /api/bill/platform/pay/queryPayChannelStatus`
 * @更新时间 `2022-10-08 11:53:57`
 */
export function getPayChannelStatus(data) {
  var opts = handleToken(UrlType.BILL);
  return fly.post("/pay/queryPayChannelStatus", data, opts);
}